import {
    ChangeDetectionStrategy,
    Component,
    inject,
    OnInit,
    signal,
} from '@angular/core'
import { RouterLink } from '@angular/router'
import { SpanishDirective } from '@baboor/baboor-language'
import { AppDetailsService } from '@baboor/common-services'
import { provideTranslocoScope, TranslocoModule } from '@jsverse/transloco'

@Component({
    selector: 'app-public-footer',
    imports: [RouterLink, TranslocoModule, SpanishDirective],
    templateUrl: './public-footer.component.html',
    styleUrl: './public-footer.component.scss',
    changeDetection: ChangeDetectionStrategy.OnPush,
    providers: [AppDetailsService, provideTranslocoScope('landing')],
})
export class PublicFooterComponent implements OnInit {
    private appDetailsService = inject(AppDetailsService)
    year = new Date().getFullYear()
    version = signal<string>('')

    async ngOnInit() {
        const appVersion = await (
            await this.appDetailsService.getAppDetails()
        ).version
        this.version.set(appVersion)
    }
}
